import { render, staticRenderFns } from "./EnterLearnerAssessmentRemark.vue?vue&type=template&id=2bb4f850&scoped=true&"
import script from "./EnterLearnerAssessmentRemark.vue?vue&type=script&lang=js&"
export * from "./EnterLearnerAssessmentRemark.vue?vue&type=script&lang=js&"
import style0 from "./EnterLearnerAssessmentRemark.vue?vue&type=style&index=0&id=2bb4f850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4f850",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol,VIcon,VRow,VSimpleTable,VSnackbar,VTextarea,VToolbar,VToolbarTitle})
